const PREFIX = "frontrow.feed.v1.";
const keyFor = (familyId) => familyId ? `${PREFIX}${familyId}` : null;

export const readCachedFeed = (familyId) => {
  const key = keyFor(familyId);
  if (!key || typeof window === "undefined") return null;
  try {
    const parsed = JSON.parse(window.localStorage.getItem(key) || "null");
    if (!parsed || typeof parsed !== "object") return null;
    if (!Array.isArray(parsed.events)) return null;
    if (!parsed.children || typeof parsed.children !== "object") return null;
    return parsed;
  } catch { return null; }
};

export const writeCachedFeed = (familyId, feed) => {
  const key = keyFor(familyId);
  if (!key || typeof window === "undefined" || !feed) return;
  try { window.localStorage.setItem(key, JSON.stringify(feed)); } catch {}
};
